// components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, MapPin, Phone, Mail, Globe } from 'lucide-react';
import FloatingWhatsApp from './FloatingWhatsApp'; // Ensure you have this component created

export default function Footer() {
  return (
    <>
      <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            
            {/* Brand Column */}
            <div className="col-span-1 md:col-span-1">
              <div className="flex items-center gap-2 mb-6">
                <GraduationCap className="text-white w-8 h-8" />
                <span className="text-xl font-bold text-white">MapYourCollege</span>
              </div>
              <p className="text-sm leading-relaxed mb-6 text-slate-400">
                Nurturing Dreams, Creating Leaders. The most trusted platform for college admissions and career counseling in India.
              </p>
              <div className="flex gap-4">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="w-8 h-8 bg-slate-800 rounded flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors cursor-pointer">
                    <Globe size={14} />
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-bold mb-6">Quick Links</h4>
              <ul className="space-y-3 text-sm">
                {['About Us', 'Colleges', 'Exams', 'Contact', 'Blog'].map((link) => (
                  <li key={link}>
                    <Link to={`/${link.toLowerCase().replace(' ', '-')}`} className="hover:text-red-500 transition-colors">
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-white font-bold mb-6">Services</h4>
              <ul className="space-y-3 text-sm">
                {[
                  'Engineering Admissions',
                  'Medical Admissions',
                  'Management Quota',
                  'Study Abroad',
                  'Counseling',
                ].map((link) => (
                  <li key={link}>
                    <Link to="/services" className="hover:text-red-500 transition-colors">
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-white font-bold mb-6">Contact Us</h4>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-red-600 shrink-0" />
                  <span>MZ-6 Dm tower Near Zanzeerwala Square, Indore </span>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-red-600 shrink-0" />
                  <span>+917771011010</span>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-red-600 shrink-0" />
                  <span>info@mapyourcollege.com</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
            <p>&copy; 2025 MapYourCollege. All rights reserved.</p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>

      {/* GLOBAL FLOATING WHATSAPP BUTTON (Included automatically) */}
      <FloatingWhatsApp />
    </>
  );
}